import React from 'react'
import Widget from './chat-widget'

import './style.css'

import arrowSrc from './arrow.svg'
import website from './website_preview.svg'

const ChatPreview = ({
  iconStyle,
  color
}) => (
    <div className='chat-preview'>
      <div className='chat-preview-message-container'>
        <Widget
          iconStyle={iconStyle}
          backgroundColor={color}
          foregroundColor="FFF"
        />
        <img className='chat-preview-message-website' src={website} alt=''/>
      </div>
      <div className='chat-preview-message'>
        <p>
          This is how Drift will appear on your website!
        </p>
        <img className="arrow-change" src={arrowSrc} alt=''/>
      </div>
    </div>
)

export default ChatPreview
